import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {LocalStorage} from '@ngx-pwa/local-storage';
import {UtilsService} from '../utils/utils.service';

@Injectable()
export class SkusService {
  private apiUrl = environment.apiUrl;
  skusUrl = `${this.apiUrl}public/skus`;
  usuario;

  constructor(private _http: HttpClient, protected _localStorage: LocalStorage, private _utilsService: UtilsService) {
    this.usuario = this._utilsService.getUsuario();
  }

  getSkus(): Observable<{}> {
    return this._http.get(`${this.skusUrl}/${this.usuario['empresa']}`)
      .pipe(map(data => {
        return data;
      }));
  }

  getSkusStorage() {
    return this._localStorage.getItem('skus');
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
